export default {
  calendar: [],
  notifications: []
};
